import Container from './StudioDeviationGrid.container';
import StudioDeviationGrid from './StudioDeviationGrid';

export default Container(StudioDeviationGrid);
